import * as React from 'react';
import { FilterStore } from '../../../stores';
import './PVASelect.css';

export class PVASelectOption {
    id: number;
    label: string;
}

interface PVAGenericSelectProps {
    options: PVASelectOption[];
    selected: number | undefined;
    onChange: Function;
    FilterStore?: FilterStore;
    defaultOptions?: any[];
    ignoreTopPosition?: boolean;
    stretch?: boolean;
    keepNoSelect?: boolean;
    noSelectTitle?: string;
}

interface PVAGenericSelectState {
    isOpen: boolean;
}

export class PVAGenericSelect extends React.Component<PVAGenericSelectProps, PVAGenericSelectState> {
    constructor(props: PVAGenericSelectProps) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    private selectedOpt() {
        if (!this.props.selected) {
            return null;
        }
        return this.props.options.find((u: PVASelectOption) => {
            return u.id === this.props.selected;
        });
    }

    private optChange(id: number) {
        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    value: id
                }
            });
        }
        this.setState({ isOpen: !this.state.isOpen });
    }

    render() {

        var selectedOpt = this.selectedOpt();

        return (
            <div className={`pva-select-box ${this.props.stretch ? 'stretch' : ''}`}>
                <div className={`pva-select-box-selected ${this.props.ignoreTopPosition === true ? 'ignore-top-position' : ''} ${this.state.isOpen ? 'open' : ''}`} onClick={(e) => this.setState({ isOpen: !this.state.isOpen })}>
                    {selectedOpt &&
                        <div className="user-row">
                            <span>{selectedOpt.label}</span>
                        </div>
                    }
                    {!selectedOpt &&
                        <div className="user-row">
                            <span>{this.props.noSelectTitle ? this.props.noSelectTitle : '- Select -'}</span>
                        </div>
                    }
                    <div className="pva-select-box-toggle">
                        {!this.state.isOpen && <span className="glyphicon glyphicon-triangle-bottom" />}
                        {this.state.isOpen && <span className="glyphicon glyphicon-triangle-top" />}
                    </div>
                </div>
                {this.state.isOpen &&
                    <div className="pva-select-box-options">
                        {this.props.keepNoSelect && <div className="user-row" onClick={(e) => this.optChange(-1)}>
                            <div className="user-name"><span>{this.props.noSelectTitle ? this.props.noSelectTitle : '- Select -'}</span></div>
                        </div>}
                        {this.props.defaultOptions && this.props.defaultOptions.map((o: any, ind: number) => {
                            return <div key={`select-default-opt-${ind}`} className="user-row" onClick={(e) => this.optChange(o.id)}>
                                <div className="user-name"><span>{o.value}</span></div>
                            </div>;
                        })}
                        {this.props.options.map((data: PVASelectOption, index: number) => {
                            return <div key={`select-opt-${data.id}`} className="user-row" onClick={(e) => this.optChange(data.id)}>
                                <div className="user-name"><span>{data.label}</span></div>
                            </div>;
                        })}
                    </div>}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAGenericSelect.tsx